import { useContext } from "react";
import style from "./modal.module.css";
import ModalProvider from "../../../context/LoanAgreementModalContextProvider";

export default function LoanAgreementModal() {
  const { setToggleModal } = useContext(ModalProvider);

  return (
    <div className={style.loanAgreementModal}>
      <div className={style.modal}>
        <div className={style.modalHeader}>
          <h5>Loan Offer Agreement</h5>
        </div>
        <div className={style.modalContent}>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
          facilis mollitia at velit debitis, consectetur unde ea dolores quam
          maiores numquam quas explicabo similique accusamus. Earum quod culpa
          placeat mollitia?
        </div>
        <div className={style.modalFooter}>
          <button
            className={style.closeModalBtn}
            onClick={() => setToggleModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
